import React from 'react';

class MortgageCalculationTable extends React.Component {
    
    render() {
    return (<div id="MortgageCalculatorTable" className='mortgage-calculator__table'>
        <h2>Loan Details</h2>
        <table>
            <thead>
                <tr>
                    <th></th>
                    <th className='bg-light-green-10'>Flex<br/>Amortised</th>
                    <th className='bg-light-green-15'>Flex<br/>Serial</th>
                    <th className='bg-light-green-10'>Advantage<br/>Amortised</th>
                    <th className='bg-light-green-15'>Advantage<br/>Serial</th>
                    {(this.props.competitorDisplay && this.props.competitorHasCalculation) && (
                    <th></th>
                    )}
                    {(this.props.competitorDisplay && this.props.competitorHasCalculation) && (
                    <th className='bg-grey'>Competitor</th>
                    )}
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className='row-label'   >Monthly payments first 5 years</td>
                    <td className='bg-light-green-10'>£ {Math.round(this.props.calcData.flexAmortised.monthlyPayments[0]).toLocaleString()}</td>
                    <td className='bg-light-green-15'>£ {Math.round(this.props.calcData.flexSerial.monthlyPayments[0]).toLocaleString()}</td>
                    <td className='bg-light-green-10'>£ {Math.round(this.props.calcData.advantageAmortised.monthlyPayments[0]).toLocaleString()}</td>
                    <td className='bg-light-green-15'>£ {Math.round(this.props.calcData.advantageSerial.monthlyPayments[0]).toLocaleString()}</td>
                    {(this.props.competitorDisplay && this.props.competitorHasCalculation) && (
                        <td className='row-label'>Monthly payments first {this.props.competitorCommitmentPeriod} years</td>
                    )}
                    {(this.props.competitorDisplay && this.props.competitorHasCalculation) && (
                        <td className='bg-grey'>£ {Math.ceil(this.props.competitorCalc.monthlyPayments[0]).toLocaleString()}</td>    
                    )}
                </tr>
                <tr>
                    <td className='row-label'>Monthly payment after 5 years</td>
                    <td className='bg-light-green-10'>£ {Math.round(this.props.calcData.flexAmortised.monthlyPayments[60]).toLocaleString()}</td>
                    <td className='bg-light-green-15'>£ {Math.round(this.props.calcData.flexSerial.monthlyPayments[60]).toLocaleString()}</td>
                    <td className='bg-light-green-10'>£ {Math.round(this.props.calcData.advantageAmortised.monthlyPayments[60]).toLocaleString()}</td>
                    <td className='bg-light-green-15'>£ {Math.round(this.props.calcData.advantageSerial.monthlyPayments[60]).toLocaleString()}</td>
                    {(this.props.competitorDisplay && this.props.competitorHasCalculation) && (
                        <td className='row-label'>Monthly payments after {this.props.competitorCommitmentPeriod} years</td>
                    )}
                    {(this.props.competitorDisplay && this.props.competitorHasCalculation) && (
                        <td className='bg-grey'>£ {Math.ceil(this.props.competitorCalc.monthlyPayments[60]).toLocaleString()}</td>    
                    )}
                </tr>
                <tr>
                    <td className='row-label'>Interest first 5 years<br/>{this.props.interestComment}</td>
                    <td className='bg-light-green-10'>{this.props.calcData.flexAmortised.interestRateFirst5Years}%</td>
                    <td className='bg-light-green-15'>{this.props.calcData.flexSerial.interestRateFirst5Years}%</td>
                    <td className='bg-light-green-10'>{this.props.calcData.advantageAmortised.interestRateFirst5Years}%</td>
                    <td className='bg-light-green-15'>{this.props.calcData.advantageSerial.interestRateFirst5Years}%</td>
                    {(this.props.competitorDisplay && this.props.competitorHasCalculation) && (
                        <td className='row-label'>Interest first {this.props.competitorCommitmentPeriod} years</td>
                    )}
                    {(this.props.competitorDisplay && this.props.competitorHasCalculation) && (
                        <td className='bg-grey'>{this.props.competitorCalc.interestRateInitialPeriod}%</td>    
                    )}
                </tr>
                <tr>
                    <td className='row-label'>Interest after 5 years<br/>{this.props.interestComment}</td>
                    <td className='bg-light-green-10'>{this.props.calcData.flexAmortised.interestRateAfter5Years}%</td>
                    <td className='bg-light-green-15'>{this.props.calcData.flexSerial.interestRateAfter5Years}%</td>
                    <td className='bg-light-green-10'>{this.props.calcData.advantageAmortised.interestRateAfter5Years}%</td>
                    <td className='bg-light-green-15'>{this.props.calcData.advantageSerial.interestRateAfter5Years}%</td>
                    {(this.props.competitorDisplay && this.props.competitorHasCalculation) && (
                        <td className='row-label'>Interest after {this.props.competitorCommitmentPeriod} years</td>
                    )}
                    {(this.props.competitorDisplay && this.props.competitorHasCalculation) && (
                        <td className='bg-grey'>{this.props.competitorCalc.interestRateExtendedPeriod}%</td>    
                    )}
                </tr>
                <tr>
                    <td className='row-label'>Total costs</td>
                    <td className='bg-light-green-10'>£ {Math.round(this.props.calcData.flexAmortised.totalFees).toLocaleString()}</td>
                    <td className='bg-light-green-15'>£ {Math.round(this.props.calcData.flexSerial.totalFees).toLocaleString()}</td>
                    <td className='bg-light-green-10'>£ {Math.round(this.props.calcData.advantageAmortised.totalFees).toLocaleString()}</td>
                    <td className='bg-light-green-15'>£ {Math.round(this.props.calcData.advantageSerial.totalFees).toLocaleString()}</td>
                    {(this.props.competitorDisplay && this.props.competitorHasCalculation) && (
                        <td className='row-label'></td>
                    )}
                    {(this.props.competitorDisplay && this.props.competitorHasCalculation) && (
                        <td className='bg-grey'></td>    
                    )}
                </tr>
            </tbody>
        </table>
    </div>);
  }
}

export default MortgageCalculationTable;
